import { IPlayer, GameEvents } from './types';
import { EventBus } from '../utils/EventBus';

/**
 * Manages turn flow for the domino game.
 */
export class TurnManager {
  private players: IPlayer[];
  private _currentPlayerIndex: number;

  constructor(players: IPlayer[]) {
    this.players = players;
    this._currentPlayerIndex = 0;
  }

  /**
   * Gets the active player.
   */
  get currentPlayer(): IPlayer {
    return this.players[this._currentPlayerIndex];
  }

  /**
   * Gets the active player's index.
   */
  get currentPlayerIndex(): number {
    return this._currentPlayerIndex;
  }

  /**
   * Advances to the next player and emits TurnStart.
   */
  public nextTurn(): void {
    const prevPlayer = this.currentPlayer;
    EventBus.emit(GameEvents.TurnEnd, { playerId: prevPlayer.id });

    this._currentPlayerIndex = (this._currentPlayerIndex + 1) % this.players.length;
    
    EventBus.emit(GameEvents.TurnStart, { playerId: this.currentPlayer.id });
  }

  /**
   * Resets the turn order.
   */
  public reset(): void {
    this._currentPlayerIndex = 0;
  }

  /**
   * Sets who goes first.
   * @param index Player index
   */
  public setStartingPlayer(index: number): void {
    if (index >= 0 && index < this.players.length) {
      this._currentPlayerIndex = index;
    }
  }
}
